<template>
  <div>
    <div class="flex flex-col sm:flex-row sm:items-center">
      <date-picker
        name="start"
        :value="start"
        class="form-input w-full sm:w-64"
        required
      ></date-picker>

      <span class="mx-2">
        {{ $t('reports.until') }}
      </span>

      <date-picker name="end" :value="end" class="form-input w-full sm:w-64" required></date-picker>
    </div>
    <div class="mt-1" v-if="presets">
      <button
        type="button"
        class="text-sm text-gray-500 hover:text-black"
        @click="showPresets = !showPresets"
      >
        Presets
        <span class="fal" :class="[showPresets ? 'fa-angle-up' : 'fa-angle-down']" />
      </button>
      <div class="flex flex-col items-start text-sm leading-normal" v-if="showPresets">
        <span
          class="cursor-pointer text-brand-500 hover:text-brand-800"
          v-for="preset in presets"
          :key="preset.name"
          @click="applyPreset(preset)"
        >
          {{ preset.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    start: {
      type: String,
      required: false,
    },
    end: {
      type: String,
      required: false,
    },
    presets: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      showPresets: false,
    }
  },
  methods: {
    applyPreset(preset) {
      this.start = preset.start
      this.end = preset.end
    },
  },
}
</script>
